import { Mail, Phone } from "lucide-react";
import { CONTACT } from "../lib/api";

export const Footer = () => {
  return (
    <footer id="contact" className="relative mt-32 border-t hairline bg-[#050505]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-24 grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
        <div className="md:col-span-7">
          <img
            src="/logo-full.png"
            alt="TDstaircase — we build quality stairs"
            className="w-64 md:w-80 select-none"
            draggable={false}
            data-testid="footer-logo"
          />
          <div className="gold-divider w-32 my-10" />
          <p className="text-muted-foreground max-w-lg leading-relaxed text-base">
            Floating staircases, replacements, hardwood flooring and custom staining —
            built by hand, finished with care.
          </p>
        </div>

        <div className="md:col-span-5">
          <p className="label-eyebrow">Get in touch</p>
          <ul className="mt-6 space-y-4 text-base">
            <li>
              <a
                href={`mailto:${CONTACT.email}`}
                className="flex items-center gap-3 text-foreground/90 hover:text-primary transition-colors"
                data-testid="footer-email"
              >
                <Mail className="h-5 w-5 text-primary" strokeWidth={1.4} />
                {CONTACT.email}
              </a>
            </li>
            <li>
              <a
                href={`tel:${CONTACT.phone.replace(/[^0-9+]/g, "")}`}
                className="flex items-center gap-3 text-foreground/90 hover:text-primary transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="h-5 w-5 text-primary" strokeWidth={1.4} />
                {CONTACT.phone}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t hairline">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm uppercase tracking-[0.22em] text-muted-foreground">
          <span>© {new Date().getFullYear()} TDstaircase · All rights reserved</span>
          <span>Crafted, not manufactured.</span>
        </div>
      </div>
    </footer>
  );
};
